import App from './App.js';
import reportWebVitals from './reportWebVitals';
import { getApp, getApps, initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import './index.css';

import store from './salon/app/store';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';

import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// E2Eテスト(Firebase Emulator)専用の分岐。REACT_APP_USE_EMULATOR=true のときのみ有効。
// 本番ビルド/通常開発では常にfalseで、本番Firebaseプロジェクトにのみ接続する。
const useEmulator = process.env.REACT_APP_USE_EMULATOR === 'true';

const firebaseConfig = useEmulator
  ? {
      apiKey: 'demo-api-key',
      authDomain: 'localhost',
      projectId: 'demo-memorii-e2e',
      storageBucket: 'demo-memorii-e2e.appspot.com',
    }
  : {
      apiKey: process.env.REACT_APP_APIKEY,
      authDomain: process.env.REACT_APP_AUTHDOMAIN,
      databaseURL: process.env.REACT_APP_DATABASEURL,
      projectId: process.env.REACT_APP_PROJECT_ID,
      storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_APP_ID,
      measurementId: process.env.REACT_APP_MEASUREMENT_ID,
    };

// ESモジュールの評価順の都合で、この行より先に他の静的import(例: 認証系ページ)側の
// initializeApp が実行されている場合があるため、既存のデフォルトアプリを再利用する。
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

if (useEmulator) {
  // ポート番号は firebase.emulator.json と合わせている(このリポジトリとは無関係な
  // 別プロジェクトのFirebase Emulatorがデフォルトポートを使用している場合があるため、
  // 衝突しないよう専用のポート帯を割り当てている)。
  connectFirestoreEmulator(db, 'localhost', 18080);
  connectAuthEmulator(auth, 'http://localhost:19099', { disableWarnings: true });
  connectStorageEmulator(storage, 'localhost', 19199);

  // 各認証ページ(0-signin.tsx, 2-confirm.tsx, judge/index.tsx等)は
  // getFunctions(app, "asia-northeast1") を個別に呼んでいるが、Functions Emulatorへの
  // 接続がこれまで一切なかったため、E2Eテスト実行時にhttpsCallableが本番Cloud Functionsへ
  // 実際にネットワーク接続してしまっていた(sendSignupVerificationEmail呼び出しが原因不明の
  // エラーになる不具合として発覚)。connectFunctionsEmulatorは(app, region)ごとに1度しか
  // 呼べないため、他のどのファイルよりも先に読み込まれるこの起点でまとめて接続する。
  connectFunctionsEmulator(getFunctions(app, 'asia-northeast1'), 'localhost', 15001);
}

const analytics = useEmulator ? null : getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();

export { db, storage, analytics, auth, app };
